import "./index.css";
import InsightItem from "../insight-item";
import LoadingState from "../loading-state";
import EmptyState from "../empty-state";

function InsightsHolder({ items, loadStatus, openSiteAdder, onDismiss }) {

  if(loadStatus === false){
    return <LoadingState />
  }
  else{
    if(items.length > 0){
      return (
        <div id="insights-holder">
        {items.map((item)=>{
          return <InsightItem key={`${item.url}-${item.dateDetected}`} item={item} onDismiss={onDismiss} />
        })}
        </div>
      );
    }
    else{
      return <EmptyState message="No insights detected. Add more sites." openSiteAdder={openSiteAdder}/>
    }

  }
}

export default InsightsHolder;